<template>
  <div>Share</div>
</template>

<script>
export default {
  name: "Share",

  data() {
    return {};
  },
  methods: {},
  mounted() {
    // const resp = this.$store.dispatch("auth/validate_lost_password", {
    //   reset_password_token: this.$route.params.token,
    // });
    // this.showFail = !!resp.success;
  },
};
</script>
